import { useMutation } from '@tanstack/react-query';
import { saveLibxSettings } from './saveLibxSettings';
import { LibXchangeSharingOptions } from '../../../../store/apiLibx';
import { TYPE_ERROR } from '../../../../shared/notification/actions';
import { invalidateLocalContentProduct } from './useLocalContentProduct';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../../../shared/notification/toastNotification';

export const useSaveLibxSettings = (productId: string) => {
    const { t } = useTranslation();

    return useMutation((sharingOptions: LibXchangeSharingOptions) => saveLibxSettings(productId, sharingOptions), {
        onSuccess: () => {
            showNotification(t('notifications.useSaveLibxSettings.success'));
            invalidateLocalContentProduct(productId).then();
        },
        onError: () => {
            showNotification(t('notifications.useSaveLibxSettings.error'), TYPE_ERROR);
        }
    });
};
